import { AUTH_HEADERS } from '@libs/core';
import type { LoyaltyMemberPoints } from '@libs/common-types';
import { client } from '../../client';
import { getAccessToken } from '../../utils';
import { CWEA_ENDPOINTS } from '../../constants';

export async function getMemberPoints() {
    const token = getAccessToken();

    if (!token) {
        return null;
    }

    const url = CWEA_ENDPOINTS.loyalty.getMemberPoints;
    return await client.cwea<LoyaltyMemberPoints>(url, {
        headers: {
            [AUTH_HEADERS.AUTHORIZATION]: `Bearer ${token}`,
        },
    });
}
